export default __webpack_public_path__ + "3ad72515725f7089944d35487938005c.svg";